module.exports = __webpack_public_path__ + "static/media/south-western_iberian_text_04.95de59e3.jpg";